module.exports = __webpack_public_path__ + "img/Clement.005f158e.jpg";